import React from 'react';

import LogInPage from '../components/signUp-LogIn/LogInPage';

export default function Login() {
  return <div>
    <LogInPage />
  </div>;
}
